module.exports = __webpack_public_path__ + "img/auto-1.030f4368.png";